import * as React from 'react';
import clsx from 'clsx';
import { ChevronRightIcon, ChevronDownIcon } from '@heroicons/react/24/solid';
import { handleQuestionClick } from './utils';
import type { SuggestedQuestionsProps } from './types';

export const SuggestedQuestions: React.FC<SuggestedQuestionsProps> = ({
  questions,
  onQuestionSelect,
  disabled,
}) => {
  const [isOpen, setIsOpen] = React.useState(false);

  // Safety check: don't render if no questions
  if (!questions || questions.length === 0) {
    return null;
  }

  return (
    <div className='flex w-full flex-col items-center gap-2 pb-2'>
      {/* Toggle Button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        type='button'
        className={clsx(
          // Dimensions & Layout: Centered fit, Padding
          'flex items-center justify-center gap-2 px-4 py-2',
          // Shape: Radius 20px, Border 1px
          'rounded-20 border border-gray-450',
          // Color: Accent-40 (#DEFFC8)
          'bg-accent-40',
          // Interaction
          'transition-all hover:brightness-95'
        )}
      >
        <span className='whitespace-nowrap font-sans text-14 font-medium text-brand-800'>
          Suggested Questions
        </span>
        {isOpen ? (
          <ChevronDownIcon className='size-4 text-brand-800' />
        ) : (
          <ChevronRightIcon className='size-4 text-brand-800' />
        )}
      </button>

      {/* Expanded List */}
      {isOpen && (
        <div className='flex w-full flex-col items-center gap-2'>
          {questions.map((question) => (
            <button
              key={question.id}
              onClick={() => !disabled && handleQuestionClick(question.text, onQuestionSelect)}
              disabled={disabled}
              className={clsx(
                // Shape: Radius 20px, Border 1px
                'rounded-20 border border-gray-450 px-6 py-3',
                // Text: Centered
                'text-center',
                // Transition
                'transition-transform',
                // Color: White BG
                'bg-white',
                // Font: Inter Medium 14px, Dark text
                'font-sans text-14 font-medium text-brand-800',
                // Responsive Width: 100% on mobile, min 40% on desktop (md+)
                'w-full md:w-auto md:min-w-[40%]',
                disabled ? 'cursor-not-allowed opacity-50' : 'hover:scale-[1.01] hover:bg-gray-50'
              )}
            >
              {question.text}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
